import { BreadcrumbItemType } from '@shared/types/global';
import { ProductRatingType } from '@shared/types/product';
import { Breadcrumbs } from '@shared/ui/Breadcrumbs';
import { Container } from '@shared/ui/Container';
import { HStack } from '@shared/ui/Stack';

import { Information } from './Information/Information';
import { Slider } from './Slider/Slider';
import cls from './Intro.module.scss';

type IntroProps = {
  breadcrumbs: BreadcrumbItemType[];
  rating?: ProductRatingType;
};

export const Intro = ({ breadcrumbs, rating }: IntroProps) => {
  return (
    <div className={cls.wrap}>
      <Breadcrumbs
        className={cls.breadcrumbs}
        data={breadcrumbs}
      />
      <Container>
        <HStack className={cls.top}>
          <Slider />
          <Information rating={rating} />
        </HStack>
      </Container>
    </div>
  );
};
